import { TupleArbitrary } from './_internals/TupleArbitrary.js';
export function tuple(...arbs) {
    return new TupleArbitrary(arbs);
}
